// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4843":"6ab5578a","4869":"38098348","8958":"38098348"}[chunkId] + ".chunk.css";
};